
import { Component, Vue, Prop } from 'vue-property-decorator'
import * as Common from '@/api/common'
import { AppModule } from '@/store/modules/app'
import { v4 as uuidv4 } from 'uuid'
import Bus from '@/utils/bus'
import { isEmpty } from '@/utils/helpers'

@Component
export default class TtsAudio extends Vue {
  @Prop({ required: true, type: String })
  ttsContent!: string

  get talkId() {
    return AppModule.talkId
  }

  get userId () {
    return AppModule.userId
  }

  get ttsList () {
    return window.config.ttsList
  }

  ttsJson: any = {
    '1': 'mandarin',
    '2': 'cantonese'
  }

  audio = new Audio()

  uuid = uuidv4()

  mounted() {
    Bus.$on('audio:pause', (uuid: string) => {
      if (this.uuid !== uuid) {
        this.audio.pause()
      }
    })
  }

  beforeDestroy() {
    Bus.$off('audio:pause')
  }

  handleClick(type: string) {
    if (isEmpty(this.ttsContent)) {
      const message: any = this.$t('ttsEmpty')
      this.$message.warning(message)
      return
    }

    const message: any = this.$t('synthesising')
    AppModule.setTip(message)
    AppModule.setSpinning(true)

    Common.audioTts({
      text: this.ttsContent,
      talkId: this.talkId,
      userId: this.userId,
      type
    }).then(data => {
      const src = 'data:audio/wav;base64,' + data
      this.playAudio(src)
      AppModule.setSpinning(false)
    }).catch((err) => {
      const { code } = err
      if (code === 10001) {
        this.$message.error(this.$t('ttsEmpty') as any)
      } else {
        this.$message.error(this.$t('ttsFail') as any)
      }
      AppModule.setSpinning(false)
    })
  }
  playAudio(src: string) {
    // 停止其他的tts合成播报
    Bus.$emit('audio:pause', this.uuid)
    // 停止单文件的音频播放
    Bus.$emit('stopAll', this.uuid)
    // 停止其他音频播放
    this.audio.src = src
    this.audio.play()
  }
}
